// update notebookCollapsed value to true/false
export function toggleNotebookCollapse(state, payload) {
  return {
    ...state,
    notebookCollapsed: payload ? payload : !state.notebookCollapsed,
  };
}
